const ANALYTICS_HOST = "operadag.ru";
const CULTURE_PIXEL_ID = "2471";
const YANDEX_METRIKA_ID = 113206253;

// Адрес последней учтённой страницы без хэша; null, пока аналитика не включена.
let lastPageUrl = null;

function currentPageUrl() {
  return location.href.split("#")[0];
}

// Вызывается один раз после старта роутера (entry-client.js). На opera.comrades.dev
// и при локальном запуске счётчики не работают.
export function initAnalytics() {
  if (location.hostname !== ANALYTICS_HOST) {
    return;
  }
  lastPageUrl = currentPageUrl();
  loadCulturePixel();
}

// Счётчик «Цифровая культура» (PRO.Культура.РФ). Пиксель шлёт просмотр на каждый
// history.pushState/replaceState, поэтому подключаем его только после старта роутера:
// роутер при инициализации делает replaceState, и первая страница посчиталась бы дважды.
function loadCulturePixel() {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://culturaltracking.ru/static/js/spxl.js?pixelId=${CULTURE_PIXEL_ID}`;
  script.setAttribute("data-pixel-id", CULTURE_PIXEL_ID);
  document.head.appendChild(script);
}

// Яндекс.Метрика (код в index.template.html) сама считает только первую страницу,
// переходы внутри SPA передаём через hit. Вызывается из App.vue, когда новая страница
// уже на экране. Смену одного хэша (#afisha/... у виджета Radario) просмотром не считаем.
export function trackMetrikaHit() {
  if (lastPageUrl === null || typeof window.ym !== "function") {
    return;
  }
  const url = currentPageUrl();
  if (url === lastPageUrl) {
    return;
  }
  window.ym(YANDEX_METRIKA_ID, "hit", url, {
    title: document.title,
    referer: lastPageUrl,
  });
  lastPageUrl = url;
}
